import { lazy } from 'react';
import { inkScreenPages, layoutMenu, paperlessPages, tencentHyPages } from '../menu';


/**
 * 基础的-登录，报错
 */
const LAYOUT_APPOINTMENT = {
	AuthLogin: lazy(() => import("../Authentication/Login")),
	Error404: lazy(() => import("../components/Custompages/Error1-404/Error-404")),
}
const layoutAppointment = [
	{
		path: layoutMenu.login.path,
		element: <LAYOUT_APPOINTMENT.AuthLogin />,
		exact: true,
	},
	{
		path: layoutMenu.page404.path,
		element: <LAYOUT_APPOINTMENT.Error404 />,
		exact: true,
	},
]
/**
 * 系统基本配置
*/
const SYSTEM_APPOINTMENT = {
	REGIONAL_MANAGEMENT: lazy(
		() => import('../components/System/meetingRoomManagement/RegionalManagement'),
	),
		
	ROOM_MANAGEMENT: lazy(
		() => import('../components/System/meetingRoomManagement/RoomManagement'),
	),
	//会议室展示管理
	ROOM_MANAGEMENT_SHOW: lazy(
		() => import('../components/System/meetingRoomManagement/RoomManagementShow'),
	),
	PERSONNEL_PREPOSITION: lazy(
		() => import('../components/System/meetingRoomManagement/PersonnelPreposition'),
	),
	EQUIPMENTTYPE_LIST: lazy(
		() => import('../components/System/equipmentManagement/EquipmentTypeList'),
	),
	EQUIPMENT_LIST: lazy(() => import('../components/System/equipmentManagement/EquipmentList')),

	//墨水屏设备管理
	InkscreenManagement: lazy(() => import('../components/System/systemSettings/InkscreenManagement')),

	//墨水屏模板管理
	InkscreenTemplateManagement: lazy(
		() => import('../components/System/systemSettings/InkscreenTemplateManagement'),
	),

	//添加墨水屏模板
	InkscreenTemplateAdd: lazy(
		() => import('../components/System/systemSettings/InkscreenTemplateAdd'),
	),
	//编辑墨水屏模板
	InkscreenTemplateEdit: lazy(
		() => import('../components/System/systemSettings/InkscreenTemplateEdit'),
	),
	
	PRODUCTS_GRID: lazy(
		() => import('../components/System/meetingRoomManagement/Grid'),
	),
	CONFIGURATION_MANAGEMENT: lazy(
		() => import('../components/System/systemManagement/ConfigurationManagement'),
	),
	//资源管理
	EQUIPMENTTYPE_ACCESS: lazy(
		() => import('../components/System/resourceAdministration/EquipmentTypeList')
	),
	MENU_MANAGEMENT: lazy(() => import('../components/System/systemManagement/MenuManagement')),
	//安装包列表
	installListManage: lazy(
		() => import('../components/System/systemSettings/InstallListManage'),
	),
	//安装包管理
	InstallationPackageManagement: lazy(
		() => import('../components/System/systemSettings/InstallationPackageManagement'),
	),
	ROLE_MANAGEMENT: lazy(() => import('../components/System/systemManagement/RoleManagement')),
	EventCenter: lazy(() => import("../components/System/systemManagement/DashboardEventCenterPage")),
	//密码管理
	PasswordManagement: lazy(
		() => import('../components/System/systemManagement/PasswordManagement'),
	),
	USER_MANAGEMENT: lazy(() => import('../components/System/systemManagement/UserManagement')),
	DIVISIONAL_MANAGEMENT: lazy(
		() => import('../components/System/systemManagement/DivisionalManagement'),
	),
	//流程管理
	WORKFLOW_LIST: lazy(
		() => import('../components/System/workFlow/WorkFlowList'),
	),

}
const systemAppointment = [
	{
		path: "meeting/meetingRoomManagement/regional-management",
		element: <SYSTEM_APPOINTMENT.REGIONAL_MANAGEMENT />,
		exact: true,
	},
	{
		path: "meeting/meetingRoomManagement/room-management",
		element: <SYSTEM_APPOINTMENT.ROOM_MANAGEMENT />,
		exact: true,
	},
		{
		path: "meeting/meetingRoomManagement/room-management-show",
		element: <SYSTEM_APPOINTMENT.ROOM_MANAGEMENT_SHOW />,
		exact: true,
	},
	{
		path: "meeting/meetingRoomManagement/personnel-preposition",
		element: <SYSTEM_APPOINTMENT.PERSONNEL_PREPOSITION />,
		exact: true,
	},
	{
		path: "meeting/equipmentManagement/equipment-type-list",
		element: <SYSTEM_APPOINTMENT.EQUIPMENTTYPE_LIST />,
		exact: true,
	},
	{
		path: "meeting/equipmentManagement/equipment-list",
		element: <SYSTEM_APPOINTMENT.EQUIPMENT_LIST />,
		exact: true,
	},
	//墨水屏设备管理
	{
		path: "paperless/systemSettings/inkscreenManagement",
		element: <SYSTEM_APPOINTMENT.InkscreenManagement />,
		exact: true,
	},
	//墨水屏模板管理
	{
		path: "/paperless/systemSettings/inkscreenTemplateManagement",
		element: <SYSTEM_APPOINTMENT.InkscreenTemplateManagement />,
		exact: true,
	},
	//添加墨水屏模板
	{
		path: `/paperless/systemSettings/inkscreenTemplateAdd/:id`,
		element: <SYSTEM_APPOINTMENT.InkscreenTemplateAdd />,
		exact: true,
	},
	//编辑墨水屏模板
	{
		path: `/paperless/systemSettings/inkscreenTemplateEdit/:id`,
		element: <SYSTEM_APPOINTMENT.InkscreenTemplateEdit />,
		exact: true,
	},
	{
		path: "meeting/meetingRoomManagement/grid",
		element: <SYSTEM_APPOINTMENT.PRODUCTS_GRID />,
		exact: true,
	},
	{
		path: "meeting/systemManagement/configuration-management",
		element: <SYSTEM_APPOINTMENT.CONFIGURATION_MANAGEMENT />,
		exact: true,
	},
	//资源管理
	{
		path: "meeting/resourceAdministration/EquipmentTypeList",
		element: <SYSTEM_APPOINTMENT.EQUIPMENTTYPE_ACCESS />,
		exact: true,
	},
	{
		path: "meeting/systemManagement/menu-management",
		element: <SYSTEM_APPOINTMENT.MENU_MANAGEMENT />,
		exact: true,
	},
	//安装包列表
	{
		path: "paperless/systemSettings/installListManage",
		element: <SYSTEM_APPOINTMENT.installListManage />,
		exact: true,
	},
	//安装包上传
	{
		path: "paperless/systemSettings/installationPackageManagement",
		element: <SYSTEM_APPOINTMENT.InstallationPackageManagement />,
		exact: true,
	},
	{
		path: "meeting/systemManagement/role-management",
		element: <SYSTEM_APPOINTMENT.ROLE_MANAGEMENT />,
		exact: true,
	},
	{
		path: 'event-center',
		element: <SYSTEM_APPOINTMENT.EventCenter />,
		exact: true,
	},
	//密码管理
	{
		path: "paperless/personalAdministration/passwordManagement",
		element: <SYSTEM_APPOINTMENT.PasswordManagement />,
		exact: true,
	},
	{
		path: "meeting/systemManagement/user-management",
		element: <SYSTEM_APPOINTMENT.USER_MANAGEMENT />,
		exact: true,
	},
	{
		path: "meeting/systemManagement/divisional-management",
		element: <SYSTEM_APPOINTMENT.DIVISIONAL_MANAGEMENT />,
		exact: true,
	},
	//流程管理
	{
		path: "meeting/systemManagement/work-flow-management",
		element: <SYSTEM_APPOINTMENT.WORKFLOW_LIST />,
		exact: true,
	},
]

/**
 * 普通会议管理系统
 */
const MEETING_APPOINTMENT = {

	Dashboard: lazy(() => import("../components/Meeting/Dashboard")),
	Dashboard2: lazy(() => import("../components/Dashboard/Dashboard")),
	Error505: lazy(() => import("../components/Custompages/Error-505/Error-505")),
	Signin: lazy(() => import("../components/Custompages/Signin/Signin")),
	Signup: lazy(() => import("../components/Custompages/Signup/Signup")),
	Lockscreen: lazy(() => import("../components/Custompages/Lockscreen/Lockscreen")),
	Resetpassword: lazy(() => import("../components/Custompages/Resetpassword/Resetpassword")),
	Forgotpassword: lazy(() => import("../components/Custompages/Forgotpassword/Forgotpassword")),
	AddProduct: lazy(() => import("../components/ECommerce/AddProduct/Addproduct")),
	Custompage: lazy(() => import("../components/Custompage")),
	Underconstructionpage: lazy(() => import("../components/UnderConstruction")),
	LazyCurrencyExchange: lazy(() => import("../components/Cryptocurrencies/CurrencyExchange/CurrencyExchange")),
	LazyCryptoDashboard: lazy(() => import("../components/Cryptocurrencies/Dashboard/Dashboard")),

	APPOINTMENTMEETING: lazy(
		() => import('../components/Meeting/bookingManagement/AppointmentMeeting'),
	),
	MEETINGNOTICE: lazy(
		() => import('../components/Meeting/bookingManagement/DashboardNoticeCenterPage'),
	),
	MY_MEETING: lazy(() => import('../components/Meeting/bookingManagement/MyMeeting')),
	MEETING_MANAGEMENT: lazy(
		() => import('../components/Meeting/bookingManagement/MeetingManagement'),
	),
	// ENTRY_MANAGEMENT: lazy(
	//     () => import('../components/Meeting/bookingManagement/EntryManagement'),
	// ),
	MEETING_REVIEW: lazy(() => import('../components/Meeting/bookingManagement/MeetingReview')),



	PRODUCTS_VIEW: lazy(
		() => import('../components/Meeting/meetingRoomManagement/ProductViewPage'),
	),
	PRODUCTS_VIEW2: lazy(
		() => import('../components/Meeting/meetingRoomManagement/ProductViewPage2'),
	),


	MEETING_STATEMENT: lazy(
		() => import('../components/Meeting/statementManagement/MeetingStatement'),
	),
	MEETING_STATEMENT2: lazy(
		() => import('../components/Meeting/statementManagement/MeetingStatement2'),
	),
	MEETING_SIGNATURE2: lazy(
		() => import('../components/Meeting/statementManagement/MeetingSignature2'),
	),
	//腾讯会议签到
	MEETING_SIGNATURETENCET: lazy(
		() => import('../components/Meeting/statementManagement/MeetingSignatureTencet'),
	),
	AuthSignup: lazy(() => import("../Authentication/Signup")),

	//腾讯会议录制地址
	Tencet_Transcribe: lazy(
		() => import('../components/Meeting/bookingManagement/TencetTranscribe'),
	),
	
	
	//周期性会议
	Meeting_Periodicity: lazy(
		() => import('../components/Meeting/bookingManagement/MeetingPeriodicity'),
	),
}

const meetingAppointment = [
	//周期性会议
	{
		path: "meeting/bookingManagement/meetingperiodicity",
		element: <MEETING_APPOINTMENT.Meeting_Periodicity />,
		exact: true,
	},
	{
		path: "meeting/dashboard",
		element: <MEETING_APPOINTMENT.Dashboard />,
		exact: true,
	},
	{
		path: "meeting/dashboard2",
		element: <MEETING_APPOINTMENT.Error505 />,
		exact: true,
	},
	{
		path: "meeting/bookingManagement/appointment-meeting",
		element: <MEETING_APPOINTMENT.APPOINTMENTMEETING />,
		exact: true,
	},
	{
		path: "meeting/bookingManagement/my-meeting",
		element: <MEETING_APPOINTMENT.MY_MEETING />,
		exact: true,
	},
	{
		path: "meeting/bookingManagement/meeting-management",
		element: <MEETING_APPOINTMENT.MEETING_MANAGEMENT />,
		exact: true,
	},
	// {
	// 	path: "meeting/bookingManagement/entry-management",
	// 	element: <MEETING_APPOINTMENT.ENTRY_MANAGEMENT />,
	// 	exact: true,
	// },
	{
		path: "meeting/bookingManagement/meeting-review",
		element: <MEETING_APPOINTMENT.MEETING_REVIEW />,
		exact: true,
	},
	

	{
		path: `meeting/meetingRoomManagement/product/:id`,
		element: <MEETING_APPOINTMENT.PRODUCTS_VIEW />,
		exact: true,
	},
	{
		path: `meeting/meetingRoomManagement/product2/:id`,
		element: <MEETING_APPOINTMENT.PRODUCTS_VIEW2 />,
		exact: true,
	},
	
	{
		path: "meeting/statementManagement/meeting-statement",
		element: <MEETING_APPOINTMENT.MEETING_STATEMENT />,
		exact: true,
	},
	{
		path: "meeting/meetingStatement",
		element: <MEETING_APPOINTMENT.MEETING_STATEMENT2 />,
		exact: true,
	},
	{
		path: "meeting/meetingSignature",
		element: <MEETING_APPOINTMENT.MEETING_SIGNATURE2 />,
		exact: true,
	},
	//腾讯会议签到
	{
		path: "meeting/meetingSignatureTencet",
		element: <MEETING_APPOINTMENT.MEETING_SIGNATURETENCET />,
		exact: true,
	},
	{
		path: "meeting/bookingManagement/meetingNotice",
		element: <MEETING_APPOINTMENT.MEETINGNOTICE />,
		exact: true,
	},
	
	//腾讯会议录制地址
	{
		path: "meeting/bookingManagement/tencettranscribe",
		element: <MEETING_APPOINTMENT.Tencet_Transcribe />,
		exact: true,
	},
	
];


/**
 * 无纸化会议管理系统
 */
const PAPERLESS_FILE = {

	PdfPreview: lazy(() => import('../components/Themepage')),

	//未完成会议列表
	NotCompletedMeeting: lazy(() => import('../components/paperless/meetingList/NotCompletedMeeting')),

	//会议详情
	MeetingDetails: lazy(() => import('../components/paperless/meetingList/_details/MeetingDetails')),

	//会议详情页
	MeetingDetail: lazy(() => import('../components/paperless/meetingList/_details/MeetingDetail')),

	//参会人员
	Participants: lazy(() => import('../components/paperless/meetingList/_details/Participants')),

	//添加参会人员
	AddParticipants: lazy(() => import('../components/paperless/meetingList/_details/AddParticipants')),
	//添加群组
	AddTeamPersonnel: lazy(() => import('../components/paperless/meetingList/_details/AddTeamPersonnel')),
	//编辑会议
	EditMeetings: lazy(() => import('../components/paperless/meetingList/_details/EditMeetings')),

	//批注记录
	AnnotationRecord: lazy(() => import('../components/paperless/meetingList/_details/AnnotationRecord')),

	//文件管理
	FileManagement: lazy(() => import('../components/paperless/meetingList/_details/FileManagement/index')),

	//视频管理
	VideoManagement: lazy(() => import('../components/paperless/meetingList/_details/VideoManagement')),

	//表决管理
	VotingManagement: lazy(
		() => import('../components/paperless/meetingList/_details/VotingManagement'),
	),

	//表决详细
	VotingDetailedManagement: lazy(
		() => import('../components/paperless/meetingList/_details/VotingDetailedManagement'),
	),

	//表决统计
	VotingStatistics: lazy(
		() => import('../components/paperless/meetingList/_details/VotingStatistics'),
	),

	// //投票组管理
	// VotingGroupManagement: lazy(
	// 	() => import('../components/paperless/meetingList/_details/VotingGroupManagement'),
	// ),

	// VotingGroupDetailedManagement: lazy(
	// 	() => import('../components/paperless/meetingList/_details/VotingGroupDetailedManagement'),
	// ),

	//消息管理
	InformationManagement: lazy(
		() => import('../components/paperless/meetingList/_details/InformationManagement'),
	),

	//会议记录
	ConferenceRecords: lazy(
		() => import('../components/paperless/meetingList/_details/ConferenceRecords'),
	),

	//座位图安排
	SeatMapArrangement: lazy(
		() => import('../components/paperless/meetingList/_details/SeatMapArrangement'),
	),

	//语音纪要
	VoiceSummary: lazy(
		() => import('../components/paperless/meetingList/_details/VoiceSummary'),
	),

	//已归档会议列表
	ArchivedMeeting: lazy(() => import('../components/paperless/meetingList/ArchivedMeeting')),

	//会议模板管理
	TemplateMeeting: lazy(() => import('../components/paperless/meetingList/TemplateMeeting')),

	
	




	

	//座位图
	MeetingRoomImg: lazy(
		() => import('../components/paperless/systemSettings/MeetingRoomImg'),
	),
	MeetingRoomImgZp: lazy(
		() => import('../components/paperless/systemSettings/MeetingRoomImgZp'),
	),

	//表决模板管理
	VotingTemplateManagement: lazy(
		() => import('../components/paperless/systemSettings/VotingTemplateManagement'),
	),

	//公共资料库
	PublicDatabase: lazy(() => import('../components/paperless/knowledgeManagement/PublicDatabase')),

	//问卷调查
	QuestionnaireView:lazy(() => import('../components/paperless/systemSettings/QuestionnaireView')),
	//表决列表
	VotingListView:lazy(() => import('../components/paperless/systemSettings/VotingListView')),
	//问卷展示
	VotingShowView:lazy(() => import('../components/paperless/systemSettings/VotingShowView')),
	FinalReportView:lazy(() => import('../components/paperless/systemSettings/FinalReportView')),
	//新的表决管理
	MeetingVotingListView: lazy(
		() => import('../components/paperless/meetingList/_details/MeetingVotingListView'),
	),
	//新的表决详细管理
	MeetingVotingDetailView: lazy(
		() => import('../components/paperless/meetingList/_details/MeetingVotingDetailView'),
	),
};

const paperlessAppointment = [
	//未完成会议列表
	{
		path: "PdfPreview/:fileMd5",
		element: <PAPERLESS_FILE.PdfPreview />,
		exact: true,
	},

	//未完成会议列表
	{
		path: paperlessPages.meetingList.subMenu.notCompletedMeeting.path,
		element: <PAPERLESS_FILE.NotCompletedMeeting />,
		exact: true,
	},
	//会议详情
	{
		path: 'paperless/meetingList/_details/meetingDetails/:id/:type',
		element: <PAPERLESS_FILE.MeetingDetails />,
		exact: true,
		hideInMenu: true,
		// componment: { MeetingDetails },
	},
	//会议详情页
	{
		path: 'paperless/meetingList/_details/meetingDetail/:id',
		element: <PAPERLESS_FILE.MeetingDetail />,
		exact: true,
		hideInMenu: true,
		// componment: { MeetingDetail },
	},
	//参会人员
	{
		path: 'paperless/meetingList/_details/participants/:id',
		element: <PAPERLESS_FILE.Participants />,
		exact: true,
		hideInMenu: true,
	},
	//添加参会人员
	{
		path: 'paperless/meetingList/_details/addParticipants/:id',
		element: <PAPERLESS_FILE.AddParticipants />,
		exact: true,
		hideInMenu: true,
	},
	//添加群组
	{
		path: 'paperless/meetingList/_details/addTeamPersonnel/:id',
		element: <PAPERLESS_FILE.AddTeamPersonnel />,
		exact: true,
		hideInMenu: true,
	},
	//编辑会议
	{
		path: 'paperless/meetingList/_details/editMeetings/:id',
		element: <PAPERLESS_FILE.EditMeetings />,
		exact: true,
		hideInMenu: true,
	},
	//批注记录
	{
		path: 'paperless/meetingList/_details/annotationRecord/:id',
		element: <PAPERLESS_FILE.AnnotationRecord />,
		exact: true,
		hideInMenu: true,
	},
	//文件管理
	{
		path: 'paperless/meetingList/_details/fileManagement/:id',
		element: <PAPERLESS_FILE.FileManagement />,
		exact: true,
		hideInMenu: true,
	},
	//视频管理
	{
		path: 'paperless/meetingList/_details/videoManagement/:id',
		element: <PAPERLESS_FILE.VideoManagement />,
		exact: true,
		hideInMenu: true,
	},
	//表决管理
	{
		path: 'paperless/meetingList/_details/votingManagement/:id',
		element: <PAPERLESS_FILE.VotingManagement />,
		exact: true,
		hideInMenu: true,
	},
	//表决详细
	{
		path: 'paperless/meetingList/_details/votingDetailedManagement/:id',
		element: <PAPERLESS_FILE.VotingDetailedManagement />,
		exact: true,
		hideInMenu: true,
	},
	//表决统计
	{
		path: 'paperless/meetingList/_details/votingStatistics/:id',
		element: <PAPERLESS_FILE.VotingStatistics />,
		exact: true,
		hideInMenu: true,
	},
	// //投票组详细
	// {
	// 	path: 'paperless/meetingList/_details/votingGroupDetailedManagement/:id',
	// 	element: <PAPERLESS_FILE.VotingGroupDetailedManagement />,
	// 	exact: true,
	// 	hideInMenu: true,
	// },
	// //投票组管理
	// {
	// 	path: 'paperless/meetingList/_details/votingGroupManagement/:id',
	// 	element: <PAPERLESS_FILE.VotingGroupManagement />,
	// 	exact: true,
	// 	hideInMenu: true,
	// },
	//消息管理
	{
		path: 'paperless/meetingList/_details/informationManagement/:id',
		element: <PAPERLESS_FILE.InformationManagement />,
		exact: true,
		hideInMenu: true,
	},
	//会议记录
	{
		path: 'paperless/meetingList/_details/conferenceRecords/:id',
		element: <PAPERLESS_FILE.ConferenceRecords />,
		exact: true,
		hideInMenu: true,
	},
	//座位图安排
	{
		path: 'paperless/meetingList/_details/seatMapArrangement/:id',
		element: <PAPERLESS_FILE.SeatMapArrangement />,
		exact: true,
		hideInMenu: true,
	},
	//语音纪要
	{
		path: 'paperless/meetingList/_details/voiceSummary/:id',
		element: <PAPERLESS_FILE.VoiceSummary />,
		exact: true,
		hideInMenu: true,
	},
	//已归档会议列表
	{
		path: paperlessPages.meetingList.subMenu.archivedMeeting.path,
		element: <PAPERLESS_FILE.ArchivedMeeting />,
		exact: true,
	},
	//会议模板管理
	{
		path: paperlessPages.meetingList.subMenu.templateMeeting.path,
		element: <PAPERLESS_FILE.TemplateMeeting />,
		exact: true,
	},
	
	

	
	
	
	
	//座位图
	{
		path: 'paperless/systemSettings/meetingRoomImg/:id',
		element: <PAPERLESS_FILE.MeetingRoomImg />,
		exact: true,
		hideInMenu: true,
	},
	//座位图
	{
		path: 'paperless/systemSettings/meetingRoomImgZp/:id/:type',
		element: <PAPERLESS_FILE.MeetingRoomImgZp />,
		exact: true,
		hideInMenu: true,
	},
	//表决模板管理
	{
		path: paperlessPages.systemSettings.subMenu.votingTemplateManagement.path,
		element: <PAPERLESS_FILE.VotingTemplateManagement />,
		exact: true,
	},
	//公共资料库
	{
		path: paperlessPages.knowledgeManagement.subMenu.publicDatabase.path,
		element: <PAPERLESS_FILE.PublicDatabase />,
		exact: true,
	},
	//问卷调查
	{
		path: 'paperless/meetingList/_details/questionnaireView/:id/:type/:meetingid',
		element: <PAPERLESS_FILE.QuestionnaireView />,
		exact: true,
		hideInMenu: true,
	},
	//问卷展示
	{
		path: 'paperless/meetingList/_details/votingShowView/:id/:type/:user',
		element: <PAPERLESS_FILE.VotingShowView />,
		exact: true,
		hideInMenu: true,
	},
	//总计展示
	{
		path: 'paperless/meetingList/_details/finalReportView/:meetingId/:votingId',
		element: <PAPERLESS_FILE.FinalReportView />,
		exact: true,
		hideInMenu: true,
	},
	{
		path: 'paperless/systemSettings/votingListView',
		element: <PAPERLESS_FILE.VotingListView />,
		exact: true,
		hideInMenu: true,
	},
	//新的表决管理
	{
		path: 'paperless/meetingList/_details/meetingVotingListView/:id',
		element: <PAPERLESS_FILE.MeetingVotingListView />,
		exact: true,
		hideInMenu: true,
	},
	//新的表决详细管理
	{
		path: 'paperless/meetingList/_details/meetingVotingDetailView/:id',
		element: <PAPERLESS_FILE.MeetingVotingDetailView />,
		exact: true,
		hideInMenu: true,
	},
];

/**
 * 语音转写
 */
const VOICE_CONVERSION = {
	PHONETIC_TRANSCRIPTION: lazy(
		() => import('../components/voice/transcription/PhoneticTranscription'),
	),
	RECORDING_TRANSCRIPTION: lazy(
		() => import('../components/voice/transcription/RecordingTranscription'),
	),
	FILTERING_MANAGEMENT: lazy(
		() => import('../components/voice/systemManagement/FilteringManagement'),
	),
	Opinion_CollectionView: lazy(
		() => import('../components/voice/transcription/OpinionCollectionView'),
	),
	Serial_PortView: lazy(
		() => import('../components/System/equipmentManagement/SerialPortView'),
	),
	Voiceprint_Database: lazy(
		() => import('../components/System/systemManagement/VoiceprintDatabase'),
	)
}
const voiceAppointment = [
	{
		path: "meeting/transcription/phonetic-transcription",
		element: <VOICE_CONVERSION.PHONETIC_TRANSCRIPTION />,
		exact: true,
	},
		{
		path: "meeting/transcription/recording-transcription",
		element: <VOICE_CONVERSION.RECORDING_TRANSCRIPTION />,
		exact: true,
	},
	{
		path: "meeting/systemManagement/filtering-management",
		element: <VOICE_CONVERSION.FILTERING_MANAGEMENT />,
		exact: true,
	},
	{
		path: "meeting/transcription/opinion-collectionView",
		element: <VOICE_CONVERSION.Opinion_CollectionView />,
		exact: true,
	},
	{
		path: "meeting/equipmentManagement/SerialPortView",
		element: <VOICE_CONVERSION.Serial_PortView />,
		exact: true,
	},
	{
		path: "meeting/systemManagement/VoiceprintDatabase",
		element: <VOICE_CONVERSION.Voiceprint_Database />,
		exact: true,
	},
]


// 墨水屏应用
const INKSCREEN_APPOINTMENT = {
	RefreshWifiHome: lazy(() => import("../components/InkScreen/RefreshWifiHome")),
	RefreshHome: lazy(() => import("../components/InkScreen/RefreshHome")),
	ModelHome: lazy(() => import("../components/InkScreen/ModelHome")),
	ZpWifiHome: lazy(() => import("../components/InkScreen/ZpWifiHome")),
	MyZpHome: lazy(() => import("../components/InkScreen/MyZpHome")),
	ZpHome: lazy(() => import("../components/InkScreen/ZpHome")),
	ApHome: lazy(() => import("../components/InkScreen/ApHome")),
}
const inkscreenAppointment = [
	{
		path: inkScreenPages.refreshWifiHome.path,
		element: <INKSCREEN_APPOINTMENT.RefreshWifiHome />,
		exact: true,
	},
	{
		path: inkScreenPages.refreshHome.path,
		element: <INKSCREEN_APPOINTMENT.RefreshHome />,
		exact: true,
	},
	{
		path: inkScreenPages.modelHome.path,
		element: <INKSCREEN_APPOINTMENT.ModelHome />,
		exact: true,
	},
	{
		path: inkScreenPages.zpWifiHome.path,
		element: <INKSCREEN_APPOINTMENT.ZpWifiHome />,
		exact: true,
	},
	{
		path: inkScreenPages.myZpHome.path,
		element: <INKSCREEN_APPOINTMENT.MyZpHome />,
		exact: true,
	},
	{
		path: inkScreenPages.zpHome.path,
		element: <INKSCREEN_APPOINTMENT.ZpHome />,
		exact: true,
	},
	{
		path: inkScreenPages.apHome.path,
		element: <INKSCREEN_APPOINTMENT.ApHome />,
		exact: true,
	},
]

///**
// * 腾讯会议管理系统
// */
//const TENCENT_FILE = {

//	PdfPreview: lazy(() => import('../components/Themepage')),

//	//未完成会议列表
//	NotCompletedMeeting: lazy(() => import('../components/tencentHy/meetingList/NotCompletedMeeting')),
//	//已归档会议列表
//	ArchivedMeeting: lazy(() => import('../components/tencentHy/meetingList/ArchivedMeeting')),
//	//签到列表
//	MEETING_SIGNATURE: lazy(() => import('../components/tencentHy/statementManagement/MeetingSignature')),
//	//模板列表
//	TemplateMeeting: lazy(() => import('../components/tencentHy/meetingList/TemplateMeeting')),
//	//会议详情模块
//	MeetingDetails: lazy(() => import('../components/tencentHy/meetingList/_details/MeetingDetails')),
//	//会议信息页
//	MeetingDetail: lazy(() => import('../components/tencentHy/meetingList/_details/MeetingDetail')),
//	//参会人员页
//	Participants: lazy(() => import('../components/tencentHy/meetingList/_details/Participants')),
//	//签到人员
//	MeetingSignatures: lazy(() => import('../components/tencentHy/meetingList/_details/MeetingSignature')),
//	//资源管理
//	EQUIPMENTTYPE_LIST: lazy(() => import('../components/tencentHy/resourceAdministration/EquipmentTypeList')),
//};

//const tencenHyAppointment = [
	
//	{
//		path: "PdfPreview/:fileMd5",
//		element: <TENCENT_FILE.PdfPreview />,
//		exact: true,
//	},

//	//未完成会议列表
//	{
//		path: tencentHyPages.meetingList.subMenu.notCompletedMeeting.path,
//		element: <TENCENT_FILE.NotCompletedMeeting />,
//		exact: true,
//	},
//	//已归档会议列表
//	{
//		path: tencentHyPages.meetingList.subMenu.archivedMeeting.path,
//		element: <TENCENT_FILE.ArchivedMeeting />,
//		exact: true,
//	},
//	//签到列表
//	{
//		path: tencentHyPages.statementManagement.subMenu.MeetingSignature.path,
//		element: <TENCENT_FILE.MEETING_SIGNATURE />,
//		exact: true,
//	},
//	//会议模板列表
//	{
//		path: tencentHyPages.meetingList.subMenu.templateMeeting.path,
//		element: <TENCENT_FILE.TemplateMeeting />,
//		exact: true,
//	},
//	//会议详情模块
//	{
//		path: tencentHyPages.meetingList._details.subMenu.MeetingDetails.path,
//		element: <TENCENT_FILE.MeetingDetails />,
//		exact: true,
//		hideInMenu: true,
//	},
//	//会议详情页
//	{
//		path: 'tencentHy/meetingList/_details/meetingDetail/:id',
//		element: <TENCENT_FILE.MeetingDetail/>,
//		exact: true,
//		hideInMenu: true,
//	},
//	//参会人员页
//	{
//		path: 'tencentHy/meetingList/_details/participants/:id',
//		element: <TENCENT_FILE.Participants/>,
//		exact: true,
//		hideInMenu: true,
//	},
//	//签到人员页
//	{
//		path: 'tencentHy/meetingList/_details/MeetingSignature/:id',
//		element: <TENCENT_FILE.MeetingSignatures/>,
//		exact: true,
//		hideInMenu: true,
//	},
//	//资源管理
//	{
//		path: "tencentHy/resourceAdministration/EquipmentTypeList",
//		element: <TENCENT_FILE.EQUIPMENTTYPE_LIST />,
//		exact: true,
//	},
//];

/**
 * 信息发布
 */
const PAPERLESS_SKIP = {

	//信息发布-素材管理
	MATERIAL_MANAGEMENT: lazy(() => import('../components/paperlessSkip/resourceManagement/materialManagement')),
	//信息发布-节目制作
	PROGRAM_PRODUCTION: lazy(() => import('../components/paperlessSkip/contentManagement/programProduction')),
	//信息发布-字幕制作
	SUBTITLE_PRODUCTION: lazy(() => import('../components/paperlessSkip/contentManagement/subtitleProduction')),
	//信息发布-内容发布
	CONTENT_PUBLISHING: lazy(() => import('../components/paperlessSkip/contentManagement/contentPublishing')),
	//信息发布-素材审核
	APPROVAL_RESOURCE: lazy(() => import('../components/paperlessSkip/moderationManagement/approvalResourceManagement')),
	//信息发布-节目审核
	APPROVAL_PROGRAM: lazy(() => import('../components/paperlessSkip/moderationManagement/approvalProgramManagement')),
	//信息发布-字幕审核
	APPROVAL_SUBTITLE: lazy(() => import('../components/paperlessSkip/moderationManagement/approvalSubtitleManagement')),

};

const requestskip = [
	//信息发布-素材管理
	{
		path: "paperlessskip/resourcemanagement/materialmanagement",
		element: <PAPERLESS_SKIP.MATERIAL_MANAGEMENT />,
		exact: true,
	},
	
	//信息发布-节目制作
	{
		path: "paperlessskip/contentmanagement/programproduction",
		element: <PAPERLESS_SKIP.PROGRAM_PRODUCTION />,
		exact: true,
	},
	
	//信息发布-字幕制作
	{
		path: "paperlessskip/contentmanagement/subtitleproduction",
		element: <PAPERLESS_SKIP.SUBTITLE_PRODUCTION />,
		exact: true,
	},

	//信息发布-内容发布
	{
		path: "paperlessskip/contentmanagement/contentpublishing",
		element: <PAPERLESS_SKIP.CONTENT_PUBLISHING />,
		exact: true,
	},


	//信息发布-素材审核
	{
		path: "paperlessskip/moderationManagement/approvalresourcemanagement",
		element: <PAPERLESS_SKIP.APPROVAL_RESOURCE />,
		exact: true,
	},

	//信息发布-节目审核
	{
		path: "paperlessskip/moderationManagement/approvalprogrammanagement",
		element: <PAPERLESS_SKIP.APPROVAL_PROGRAM />,
		exact: true,
	},

	//信息发布-字幕审核
	{
		path: "paperlessskip/moderationManagement/approvalsubtitlemanagement",
		element: <PAPERLESS_SKIP.APPROVAL_SUBTITLE />,
		exact: true,
	},
];


/**
 * 智能会控管理系统
 */
const INTELLIGENT_FILE = {
	//集中控制
	CentralizedControl: lazy(() => import('../components/intelligent/concentrate/CentralizedControl')),
	//设备管理
	EquipmentManagement: lazy(() => import('../components/intelligent/equipment/EquipmentManagement')),
	//会议配置
	MeetingConfiguration: lazy(() => import('../components/intelligent/concentrate/MeetingConfiguration')),
	//会议管理
	MeetingControl: lazy(() => import('../components/intelligent/concentrate/MeetingControl')),
	//中控页面生成
	CenterControlViewEdit: lazy(() => import('../components/intelligent/visualization/CenterControlViewEdit')),
	//中控页面
	CenterControlView: lazy(() => import('../components/intelligent/visualization/CenterControlView')),
	//设备事件
	EquipmentEvents: lazy(() => import('../components/intelligent/concentrate/EquipmentEvents')),
	//信息通知查看
	ScreenService:lazy(()=>import('../components/intelligent/concentrate/ScreenService')),
	//展厅数据显示页面
	CenterControlViewDataMap: lazy(() => import('../components/intelligent/visualization/CenterControlViewDataMap')),
}
const intelligentAppointment = [
	//
	{
		path: 'intelligent/concentrate/CentralizedControl',
		element: <INTELLIGENT_FILE.CentralizedControl />,
		exact: true,
	},
	//
	{
		path: 'intelligent/equipment/EquipmentManagement',
		element: <INTELLIGENT_FILE.EquipmentManagement />,
		exact: true,
	},
	//
	{
		path: 'intelligent/concentrate/MeetingConfiguration',
		element: <INTELLIGENT_FILE.MeetingConfiguration />,
		exact: true,
	},
	//
	{
		path: 'intelligent/concentrate/MeetingControl',
		element: <INTELLIGENT_FILE.MeetingControl />,
		exact: true,
	},
	//
	{
		path: 'intelligent/concentrate/CenterControlViewEdit/:id',
		element: <INTELLIGENT_FILE.CenterControlViewEdit />,
		exact: true,
	},
	//
	{
		path: 'intelligent/concentrate/CenterControlView/:id',
		element: <INTELLIGENT_FILE.CenterControlView />,
		exact: true,
	},
	//
	{
		path: 'intelligent/concentrate/EquipmentEvents',
		element: <INTELLIGENT_FILE.EquipmentEvents />,
		exact: true,
	},
	{
		path:'intelligent/concentrate/ScreenService',
		element:<INTELLIGENT_FILE.ScreenService />,
		exact:true
	},
	{
		path:'intelligent/concentrate/CenterControlViewDataMap',
		element:<INTELLIGENT_FILE.CenterControlViewDataMap />,
		exact:true
	}
]




const contents = [
	...meetingAppointment,
	...paperlessAppointment,
	...voiceAppointment,
	...layoutAppointment,
	...inkscreenAppointment,
// 	...tencenHyAppointment,
	...intelligentAppointment,
	...requestskip,
	...systemAppointment
];

export default contents;